import { createSelector } from 'reselect'

const upgradeNotetakerSpotlightSelector = (state) => state.upgradeBanner.upgradeNotetakerSpotlight

export const isUpgradeNotetakerSpotlightVisibleSelector = createSelector(
  upgradeNotetakerSpotlightSelector,
  (spotlight) => spotlight.isVisible
)
